export default __webpack_public_path__ + "static/media/flag-jordan.f073731e.svg";